import { HttpParams } from '@angular/common/http';
import { Component, OnInit, HostListener, ElementRef } from '@angular/core';
// import { Options } from '@angular-slider/ngx-slider';
import { Options } from "@angular-slider/ngx-slider";
import { DataFlightService, HttpService, LoaderService, UtilityFlightService, UtilityService, XchangeratesService } from 'src/app/services';
import { AirlinelistComponent } from '../airlinelist/airlinelist.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CryptoService } from 'src/app/services/crypto.service';

@Component({
  selector: 'app-round-way',
  templateUrl: './round-way.component.html',
  styleUrls: ['./round-way.component.scss'],
})
export class RoundWayComponent implements OnInit {
  @HostListener('window:resize', [])
  isLoading: boolean = false;
  isBookingLoader: boolean = false;
  noFlightError: boolean = false;
  trip_type: any;
  filter = false;
  list: any[] = [];
  flightList: any;
  flight_data: any;
  flight_Details: boolean[][] = [];
  selectedItem: any = "";
  selectedItems: any[][] = [];
  select_list: any = [];
  value: number = 0;
  minValue: number;
  maxValue: number ;
  stops: any[] = this.data.stopList;
  flightTime = this.data.flightTime;
  flightTimeArr = this.data.flightTime__;
  originalFlights: any[]; 
  activeStates: { id: number, value: number, isSelected: boolean }[][] = this.stops.map(item =>
    this.stops.map(stop => ({
      id: stop.id,
      value: stop.value,
      isSelected: stop.isSelected,
      arr : this.flightTimeArr
    }))
  );
  activeTime:{ id: number, isSelected_: boolean}[][]= this.flightTimeArr.map(item=>
    this.flightTimeArr.map(arr=>({
      id: arr.id,
      isSelected_: arr.isSelected_
    }))
    );
    activeTimedep:{ id: number, isSelected: boolean}[][]= this.flightTime.map(item=>
      this.flightTime.map(arr=>({
        id: arr.id,
        isSelected: arr.isSelected
      }))
      );
  resultAmount: any = [];
  uniqueCarrierNames: any = [];
  flight_list: any [] = [];
  flight_list_filter: any [] = [];
  options: Options = {
    floor: 0,
    ceil: 0
  };
  minValueList0: number = 0;
  maxValueList0: number = 100000;
  minValueList1: number = 0;
  maxValueList1: number = 100000;
  sortByOption: string = '';
  flightOccursBefore: boolean = false;
  flightOccursMsg
  isMobileView: boolean = false;

  constructor(public http: HttpService, public loaderService: LoaderService, public util: UtilityService,public data: DataFlightService,
    private dialog: MatDialog, private route: ActivatedRoute, private cryptoService: CryptoService, private router: Router, public util_flight: UtilityFlightService,
    public Xchangerates: XchangeratesService, private eRef: ElementRef) {
    this.trip_type = JSON.parse(localStorage.getItem('flight_search')!);
    this.joinApiResponses();
    // this.loaderService.isLoading.next(true);
    localStorage.removeItem('flightSelect_0');
    localStorage.removeItem('flightSelect_1');
    localStorage.removeItem('flight_list_filter__');
    localStorage.removeItem('PassangerRule');
  }

  ngOnInit(): void {
    this.initializeValues();
    this.checkMobileView();
  }
  onResize() {
    this.checkMobileView();
  }
  private checkMobileView() {
    this.isMobileView = window.innerWidth <= 768; 
  }

  currentSortOrder_0: 'asc' | 'desc' = 'asc';
  currentSortOrder_1: 'asc' | 'desc' = 'asc';
  
  sortByDepartureTime(listName: string): void {
    const listIndex = this.list.findIndex(list => list.name === listName);
    const flightList = this.list[listIndex].flightlist.filter(item => !item.hasOwnProperty('banner_id'));
    
    const currentOrder = listName === 'flightlist_0' ? this.currentSortOrder_0 : this.currentSortOrder_1;
    const newOrder = this.toggleSortOrder(currentOrder);
    listName === 'flightlist_0' ? this.currentSortOrder_0 = newOrder : this.currentSortOrder_1 = newOrder;
  
    flightList.sort((a, b) => this.compareDepartureTime(a, b) * (newOrder === 'asc' ? 1 : -1));
    this.list[listIndex].flightlist = flightList;
  }
  
  toggleSortOrder(currentOrder: 'asc' | 'desc'): 'asc' | 'desc' {
    return currentOrder === 'asc' ? 'desc' : 'asc';
  }
  
  compareDepartureTime(flightA: any, flightB: any): number {
    return this.getFlightTime(flightA) - this.getFlightTime(flightB);
  }

  // Function to sort the flight list by price and toggle sort order
  sortByPrice(listName: string): void {
    const listIndex = this.list.findIndex(list => list.name === listName);
    const flightList = this.list[listIndex].flightlist.filter(item => !item.hasOwnProperty('banner_id')); // Filter out banners

    // Toggle sort order based on the current order for the specified list
    let sortOrder;
    if (listName === 'flightlist_0') {
      this.currentSortOrder_0 = this.toggleSortOrder(this.currentSortOrder_0);
      sortOrder = this.currentSortOrder_0;
    } else if (listName === 'flightlist_1') {
      this.currentSortOrder_1 = this.toggleSortOrder(this.currentSortOrder_1);
      sortOrder = this.currentSortOrder_1;
    }

    // Perform sorting based on the current sort order
    flightList.sort((a, b) => this.comparePrice(a, b, sortOrder));

    // Update the flightlist with sorted data
    this.list[listIndex].flightlist = flightList;
  }

  // Function to compare prices of flights for sorting
  comparePrice(flightA: any, flightB: any, sortOrder: string): number {
    const priceA = flightA.flightfare?.totalnet || 0;
    const priceB = flightB.flightfare?.totalnet || 0;

    if (sortOrder === 'asc') {
      return priceA - priceB;
    } else {
      return priceB - priceA; // For descending order
    }
  }
  getArrivalTimeIn(flight: any): number {
    const arrtime = flight.flightlegs?.[0]?.[flight.flightlegs[0].length - 1]?.arrtime || '00:00';
    return parseInt(arrtime.replace(':', ''), 10);
  }

  // Function to sort the flight list by arrival time and toggle sort order
  sortByArrivalTime(listName: string): void {
    const listIndex = this.list.findIndex(list => list.name === listName);
    const flightList = this.list[listIndex].flightlist.filter(item => !item.hasOwnProperty('banner_id')); // Filter out banners

    // Toggle sort order based on the current order for the specified list
    if (listName === 'flightlist_0') {
      this.currentSortOrder_0 = this.toggleSortOrder(this.currentSortOrder_0);
    } else if (listName === 'flightlist_1') {
      this.currentSortOrder_1 = this.toggleSortOrder(this.currentSortOrder_1);
    }

    // Perform sorting based on the current sort order
    if (listName === 'flightlist_0' && this.currentSortOrder_0 === 'asc') {
      flightList.sort((a, b) => this.compareArrivalTime(a, b));
    } else if (listName === 'flightlist_0' && this.currentSortOrder_0 === 'desc') {
      flightList.sort((a, b) => this.compareArrivalTime(b, a)); // Reverse order
    } else if (listName === 'flightlist_1' && this.currentSortOrder_1 === 'asc') {
      flightList.sort((a, b) => this.compareArrivalTime(a, b));
    } else if (listName === 'flightlist_1' && this.currentSortOrder_1 === 'desc') {
      flightList.sort((a, b) => this.compareArrivalTime(b, a)); // Reverse order
    }

    // Update the flightlist with sorted data
    this.list[listIndex].flightlist = flightList;
  }

  // Function to compare arrival times of flights for sorting
  compareArrivalTime(flightA: any, flightB: any): number {
    const arrivalTimeA = this.getArrivalTimeIn(flightA);
    const arrivalTimeB = this.getArrivalTimeIn(flightB);
    return arrivalTimeA - arrivalTimeB;
  }

  getFlightDurationInMinutes(flight: any): number {
    const duration = flight.totaljourneyduration || -1; // Default to -1 for invalid duration
    return typeof duration === 'number' ? duration : Number.MAX_SAFE_INTEGER;
  }

  // Function to sort the flight list by duration and toggle sort order
  sortByDuration(listName: string): void {
    const listIndex = this.list.findIndex(list => list.name === listName);
    const flightList = this.list[listIndex].flightlist.filter(item => !item.hasOwnProperty('banner_id')); // Filter out banners

    // Toggle sort order based on the current order for the specified list
    if (listName === 'flightlist_0') {
      this.currentSortOrder_0 = this.toggleSortOrder(this.currentSortOrder_0);
    } else if (listName === 'flightlist_1') {
      this.currentSortOrder_1= this.toggleSortOrder(this.currentSortOrder_1);
    }

    // Perform sorting based on the current sort order
    if (listName === 'flightlist_0' && this.currentSortOrder_0 === 'asc') {
      flightList.sort((a, b) => this.compareDuration(a, b));
    } else if (listName === 'flightlist_0' && this.currentSortOrder_0 === 'desc') {
      flightList.sort((a, b) => this.compareDuration(b, a)); // Reverse order
    } else if (listName === 'flightlist_1' && this.currentSortOrder_1 === 'asc') {
      flightList.sort((a, b) => this.compareDuration(a, b));
    } else if (listName === 'flightlist_1' && this.currentSortOrder_1 === 'desc') {
      flightList.sort((a, b) => this.compareDuration(b, a)); // Reverse order
    }

    // Update the flightlist with sorted data
    this.list[listIndex].flightlist = flightList;
  }

  // Function to compare durations of flights for sorting
  compareDuration(flightA: any, flightB: any): number {
    const durationA = this.getFlightDurationInMinutes(flightA);
    const durationB = this.getFlightDurationInMinutes(flightB);
    return durationA - durationB;
  }
  getMinValue(listName: string): number {
    return this.getMinValueList(listName, 'min');
  }

  getMaxValue(listName: string): number {
    return this.getMinValueList(listName, 'max');
  }

  getMinValueList(listName: string, type: 'min' | 'max'): number {
    const index = listName === 'flightlist_0' ? 0 : 1;
    const initialValue = type === 'min' ? Infinity : 0;
    const reducer = (acc: number, flight: any) => {
      const totalNet = flight.flightfare?.totalnet;
      return totalNet != null ? (type === 'min' ? Math.min(acc, totalNet) : Math.max(acc, totalNet)) : acc;
    };
    // console.log(this.list[0].result , this.list[index].flightlist.reduce(reducer, initialValue));
    return this.list[index].flightlist.reduce(reducer, initialValue);
  }

  onValueChange(event: any, listName: string): void {
    const minValueKey = `minValueList${listName[listName.length - 1]}`;
    const maxValueKey = `maxValueList${listName[listName.length - 1]}`;
    this[minValueKey] = event.value;
    this[maxValueKey] = event.highValue;
    this.filterFlights(listName);
  }
  
  filterFlights(listName: string): void {
    const flightDataFromStorage = JSON.parse(localStorage.getItem('flight_list_filter__'));
    const listIndex = listName === 'flightlist_0' ? 0 : 1;
    const originalFlights = flightDataFromStorage[listIndex].flightlist;
    const minValue = listName === 'flightlist_0' ? this.minValueList0 : this.minValueList1;
    const maxValue = listName === 'flightlist_0' ? this.maxValueList0 : this.maxValueList1;
    const filteredFlights = originalFlights.filter(
      (flight: any) =>
        flight.flightfare &&
        flight.flightfare.totalnet != null &&
        flight.flightfare.totalnet >= minValue &&
        flight.flightfare.totalnet <= maxValue
    );
    this.list[listIndex].flightlist = filteredFlights;
    // console.log(filteredFlights, minValue, maxValue);
    
  }

  joinApiResponses() {
    this.isLoading = true;
    const flightId = [this.trip_type.one_way, this.trip_type.round_way];
    const apiResponses: any[] = [];
    flightId.forEach((flightList, index) => {
      const flight_id = index + 0; // Dynamic flight_id based on index
      this.http.flightsave('apiV2/flight/search', flightList).subscribe((res: any) => {
        if (res.statusCode === 200) {
          const response = {
            name: `flightlist_${flight_id}`,
            flightlist: res.data.flightjourneys,
            totalFlight: res.data.totalresults,
            requestSearch: res.data.flightsearchrequest,
            stopsList: this.stops,
            flightTime: {arrivalTime: this.data.flightTime, departTime: this.data.flightTime__}
          };
          apiResponses.push(response);
          if (apiResponses.length === flightId.length) {
            this.lowhighList(apiResponses);
            this.carrer_list(apiResponses);
            this.fetchBannerList(apiResponses); // Fetch banner list after all API responses are collected
          }
        } else if (res.errorCode === 200) {
          this.isLoading = false;
          this.noFlightError = true;
        }
      }, err => {this.util.errorMessage(err)});
    });
  }

  lowhighList(apiResponses: any[]): void {
    if (apiResponses.length === 0) {
      // console.log('The mergedList is empty.');
      return;
    }
    const separatedLists: Record<string, any[]> = {};
    apiResponses.forEach(response => {
      const { name, flightlist } = response;
      if (name && flightlist && Array.isArray(flightlist)) {
        flightlist.forEach(flight => {
          const { flightfare } = flight;
          if (flightfare) {
            separatedLists[name] = separatedLists[name] || [];
            separatedLists[name].push(flightfare);
          }
        });
      }
    });

    const listAirlince: any[] = [];
    for (const name in separatedLists) {
      const totalnetValues = separatedLists[name].map(flightfare => flightfare.totalnet);
      const lowestValue = Math.min(...totalnetValues);
      const highestValue = Math.max(...totalnetValues);
      const resultAmount = ({ name, amount: { lowest: lowestValue, highest: highestValue } });
      this.minValue = lowestValue;
      this.maxValue = highestValue;
      this.options.floor = lowestValue;
      this.options.ceil = highestValue;
      listAirlince.push(resultAmount);
    }
    this.resultAmount = listAirlince;
  }

  carrer_list(apiResponses: any[]): void {
    if (apiResponses.length === 0) {
      // console.log('The mergedList is empty.');
      return;
    }
    apiResponses.forEach(response => {
      const { name, flightlist } = response;
      if (name && flightlist && Array.isArray(flightlist)) {
        const flightlegs = flightlist.flatMap(flight => flight.flightlegs || []);
        const flightlegsStop = flightlist.flatMap(flight => flight.layovers || []);
        const layoverCount = flightlegsStop.length ? [...new Set(flightlegsStop.map(obj => Object.keys(obj).length))] : [0];
        
        if (flightlegs.length > 0) {
          const allCarrierNames: string[] = flightlegs.flatMap(leg => `${leg[0].carriername} (${leg[0].carrier})`);
          const uniqueCarrier = [...new Set(allCarrierNames)];
          const uniqueCarrierNames_ = uniqueCarrier.map(carrier => {
            const code = carrier.match(/\((.*?)\)/)?.[1] || ''; // Extract code between parentheses
            return { name: carrier, code: code, isSelected: false };
          })
          const resultCarrierNames = ({ name, list: uniqueCarrierNames_, layoverCountList: layoverCount // Include layoverCount here
          });
          // console.log(resultCarrierNames);
          this.uniqueCarrierNames.push(resultCarrierNames);
        }
      }
    });
  }


  fetchBannerList(apiResponses: any[]): void {
    let bannerlist: any[] = [];

    if (this.router.url.includes('/cheap-flights')) {
      this.http.flightget('apiV2/bookingClass/search-page-banner-list').subscribe(
        (res: any) => {
          const bannerPromo = this.util_flight.getFlightsByType();
          bannerlist = res.data?.filter((item: any) =>
            item.way_type === 'BOTH' ||
            (item.way_type === 'DOMESTIC' && ['domestic', 'both'].includes(bannerPromo.type)) ||
            (item.way_type === 'INTERNATIONAL' && ['international', 'both'].includes(bannerPromo.type))
          ).sort((a: any, b: any) =>
            a.banner_priority === null ? 1 : b.banner_priority === null ? -1 : a.banner_priority - b.banner_priority
          ) || [];
        }, (err: any) => (err)
      );
    }
    apiResponses.forEach(apiResponse => {
      const mergedList = apiResponse.flightlist.map((flightItem: any, j: number) => ({
        ...flightItem, name: 'flight'
      })).reduce((list: any[], flightItem: any, j: number) => {
        list.push(flightItem);
        if ((j + 1) % 5 === 0 && j !== apiResponse.flightlist.length - 1 && bannerlist.length) {
          list.push({ ...bannerlist[(j / 5) % bannerlist.length], name: 'banner' });
        }
        return list;
      }, []);
      apiResponse.flightlist = mergedList;
      // console.log(mergedList, 'mergedList');
      this.isLoading = false;
    });
    
    this.list = this.flight_list_filter = apiResponses
    .sort((a, b) => a.name.localeCompare(b.name))
    .map(selectItem => ({
      ...selectItem,
      stopsLists: selectItem.stopsList?.filter(stop => 
        this.uniqueCarrierNames.find(carrier => carrier.name === selectItem.name)
          ?.layoverCountList?.includes(stop.id)
      ) || [],
      result: this.resultAmount.find(res => res.name === selectItem.name),
      uniqueCarrier: this.uniqueCarrierNames.find(carrier => carrier.name === selectItem.name)
  }));

    // console.log(this.list);
    
    localStorage.setItem('flight_list_filter__', JSON.stringify(this.list));
    
    if (!localStorage.getItem('flightSelect_0') && !localStorage.getItem('flightSelect_1')) {
      const selects = ['Departure', 'Return'].map((title, i) => ({
        list: [this.list[i].flightlist[0]],
        name: this.list[i].name,
        title
      }));
      selects.forEach((select, i) => localStorage.setItem(`flightSelect_${i}`, JSON.stringify(select)));

      this.select_list = selects;
      this.selectedItems = this.select_list.map((listItem, listIndex) =>
        listItem.list.map((item: any) => ({ ...item, isSelected: this.isSelected(listIndex, listItem.list.indexOf(item)) }))
      );
      // console.log(this.select_list);
      const { arrdate = '', arrtime = '' } = this.select_list[0].list[0].flightlegs[0].at(-1) || {};
      const { depdate = '', deptime = '' } = this.select_list[1].list[0].flightlegs[0][0] || {};
      this.flightOccursBefore = new Date(`${arrdate} ${arrtime}`) > new Date(`${depdate} ${deptime}`);
      this.flightOccursMsg = this.flightOccursBefore ? 'Please choose another option as the departure flight occurs before the return flight.' : '';
      // console.log(this.flightOccursBefore ? this.flightOccursMsg : 'Flights are scheduled correctly.');
      this.isLoading = false;
    }
  }


  flightInfo(j: number, i: number): void {
    if (!this.flight_Details[j]) {
      this.flight_Details[j] = [];
    }
    this.flight_Details[j][i] = !this.flight_Details[j][i];
  }


  select__(newValue: any[]): void {
    const listIndex = newValue[0];
    const flightIndex = newValue[1];

    // Deselect previously selected item in the same list
    if (this.selectedItems[listIndex]) {
      this.selectedItems[listIndex].fill(false);
    } else {
      this.selectedItems[listIndex] = Array(this.list[listIndex]['flightlist'].length).fill(false);
    }

    // Select the new item
    this.selectedItems[listIndex][flightIndex] = true;

    // Automatically select the first item if no item has been selected yet
    if (!this.selectedItems.some(list => list.includes(true))) {
      this.selectedItems[0][0] = true;
    }
  }

  isSelected(listIndex: number, flightIndex: number): boolean {
    return this.selectedItems[listIndex]?.[flightIndex];
  }

  select(newValue: any[]): void {
    const selectedItems_oneWay = [];
    const selectedItems_returnWay = [];
    // This list show for arrivale
    for (const item of newValue) {
      if (item.name === 'flightlist_0') {
        selectedItems_oneWay.push(newValue[1]);
        // Add name field to each item
        // Log the selected items with the added name field
        const flightSelect_0 = {
          list: selectedItems_oneWay,
          name: item.name,
          title: 'Departure'
        };
        localStorage.setItem('flightSelect_0', JSON.stringify(flightSelect_0));
      }
    }
    // This list show for Return Way
    for (const item of newValue) {
      if (item.name === 'flightlist_1') {
        selectedItems_returnWay.push(newValue[1]);
        // Add name field to each item
        // Log the selected items with the added name field
        const flightSelect_1 = {
          list: selectedItems_returnWay,
          name: item.name,
          title: 'Arrival'
        };
        localStorage.setItem('flightSelect_1', JSON.stringify(flightSelect_1));
      }
    }
    const mergedList = [];
    const flightSelect_0 = JSON.parse(localStorage.getItem('flightSelect_0'));
    const flightSelect_1 = JSON.parse(localStorage.getItem('flightSelect_1'));
    if (flightSelect_0) {
      mergedList.push(flightSelect_0);
    }
    if (flightSelect_1) {
      mergedList.push(flightSelect_1);
    }
    this.select_list = mergedList;
    const { arrdate = '', arrtime = '' } = this.select_list[0].list[0].flightlegs[0].at(-1) || {};
    const { depdate = '', deptime = '' } = this.select_list[1].list[0].flightlegs[0][0] || {};
    this.flightOccursBefore = new Date(`${arrdate} ${arrtime}`) > new Date(`${depdate} ${deptime}`);
    this.flightOccursMsg = this.flightOccursBefore ? 'Please choose another option as the departure flight occurs before the return flight.' : '';
    // console.log(this.flightOccursBefore ? this.flightOccursMsg : 'Flights are scheduled correctly.');
  }



  submit() {
    this.isLoading = false;
    this.isBookingLoader = true;
    var rc_0 = this.select_list[0].list[0].flightdeeplinkurl;
    var rc_1 = this.select_list[1].list[0].flightdeeplinkurl;
    // Assuming you already have rc_0 and rc_1 defined
    const rc1 = rc_0.substring(rc_0.indexOf('rc=') + 3, rc_0.indexOf('&ts='));
    const rc2 = rc_1.substring(rc_1.indexOf('rc=') + 3, rc_1.indexOf('&ts='));

    const decodeRc1 = decodeURIComponent(rc1);
    const decodeRc2 = decodeURIComponent(rc2);

    const rc1Array = JSON.parse(decodeRc1);
    const rc2Array = JSON.parse(decodeRc2);
    const mainArray = rc1Array.concat(rc2Array);

    const mainRc = 'rc=' + encodeURIComponent(JSON.stringify(mainArray));
    // Create a regular expression to match the "rc" parameter in the URL
    const rcRegex = new RegExp('rc=' + encodeURIComponent(rc1), 'g');


    // Replace the old "rc" value with the new "mainRc" value in rc_0
    const updatedRc_0 = rc_0.replace(rcRegex, mainRc);

    // Create the new URL with the updated "rc" value
    const mainLink = updatedRc_0.substring(0, updatedRc_0.indexOf('rc=')) + mainRc + updatedRc_0.substring(updatedRc_0.indexOf('&ts='));

    // Create a URL object to parse the mainLink
    const urlObject = new URL(mainLink);

    // Get the search (query parameters) from the URL object
    const search = urlObject.search;

    this.http.flightgetall(`apiV2/flight/searchlink${search}`).subscribe((res) => {
      if(res) {
        const bookingId = this.cryptoService.encrypt(res.booking_id);
        localStorage.setItem('bookingId', bookingId);
        localStorage.setItem('trip_type__', 'roundTrip');
        const id = res.booking_id;
        localStorage.setItem('PassangerRule', JSON.stringify(res));
        // Restore main screen scrolling
        document.body.style.overflow = 'auto';
        // this.util_flight.pushPassangerRule(res);
        this.router.navigate([`../bookings/${id}`], { relativeTo: this.route }); // This will be used in future after getting payment result
        // const url = this.router.createUrlTree([`../bookings/${id}`], { relativeTo: this.route }).toString();
        // window.open(url, '_blank');
        this.isBookingLoader = true;
        // this.router.navigate([`../../booking/${id}`], { relativeTo: this.route }); // This will be used in future after getting payment result
      }
    }, err => {this.util.errorMessage(err)});
  }

  airlinelist(item) {
    const selectedItems = item.list.filter(i => i.isSelected);
    this.dialog.open(AirlinelistComponent, {
      data: { allItems: item.list, selectedItems },
      width: '520px',
      panelClass: 'flight_airlinelist-dialog-container'
    })
  }

  // Filter Code Round way trip

  filter_airline(item: any, item_: any) {
    if (item_ === 'flightlist_0' || item_ === 'flightlist_1') {
      item.isSelected = !item.isSelected;
      const listIndex = item_ === 'flightlist_0' ? 0 : 1;
      const updateCarriers = this.list[listIndex].uniqueCarrier.list;
      this.flight_list = this.filterFlightList(updateCarriers, listIndex);
      this.list[listIndex].filteredFlightList = this.flight_list; // Store the filtered flight list for reference
      this.list[listIndex].flightlist = this.applyStopFilter(this.flight_list, listIndex); // Reapply the stop filter after airline filter
    }
  }
  
  filterFlightList = (updateCarriers: any[], index: number) => {
    const flightListFilter = JSON.parse(localStorage.getItem('flight_list_filter__'));
    const selectedItem = updateCarriers.find(item => item.isSelected);
    return selectedItem
      ? flightListFilter[index].flightlist.filter(flight =>
          flight.flightlegs && flight.flightlegs.flat().some(flightleg =>
            updateCarriers.some(selectedItem => selectedItem.isSelected && flightleg.carrier === selectedItem.code)
          )
        )
      : flightListFilter[index].flightlist;
  }
  
  selectStop(item: any, item_: string): void {
    if (item_ === 'flightlist_0' || item_ === 'flightlist_1') {
      const listIndex = item_.includes('flightlist_0') ? 0 : 1;
      const stopsListCopy = JSON.parse(JSON.stringify(this.list[listIndex].stopsList));
      const stopToUpdate = stopsListCopy.find(stop => stop.id === item.id);
      if (stopToUpdate) {
        stopToUpdate.isSelected = !stopToUpdate.isSelected;
      }
      this.list[listIndex].stopsList = stopsListCopy;
      this.activeStates[listIndex][item.id].isSelected = !item.isSelected;
  
      // Apply stop filter based on current state
      const filteredFlightsByAirline = this.list[listIndex].filteredFlightList || this.list[listIndex].flightlist;
      this.list[listIndex].flightlist = this.applyStopFilter(filteredFlightsByAirline, listIndex);
    }
  }
  
  applyStopFilter = (flights: any[], listIndex: number) => {
    const selectedStops = this.list[listIndex].stopsList.filter(stop => stop.isSelected).map(stop => stop.value);
    return selectedStops.length === 0 ? flights :
      flights.filter(flight =>
        flight.name === 'flight' &&
        (selectedStops.includes(flight.layovers ? Object.keys(flight.layovers[0]).length : "non-stop") ||
        (!flight.layovers && selectedStops.includes("non-stop")))
      );
  }                     

  selectedDepartureTimeRanges: { startTime: string, endTime: string }[][] = [[], []];
  selectedArrivalTimeRanges: { startTime: string, endTime: string }[][] = [[], []];

  selectDepart(item: any, listname: any) {
    const listIndex = this.list.findIndex(list => list.name === listname);
    const selectedItem = this.activeTimedep[listIndex][item.id];
    selectedItem.isSelected = !selectedItem.isSelected;
    const timeRanges = ['00:00-12:00', '12:01-18:00', '18:01-23:59'];
    const [startTime, endTime] = timeRanges[item.id].split('-');

    // Update selectedDepartureTimeRanges based on selection
    selectedItem.isSelected
      ? this.selectedDepartureTimeRanges[listIndex].push({ startTime, endTime })
      : this.selectedDepartureTimeRanges[listIndex] = this.selectedDepartureTimeRanges[listIndex].filter(
        range => range.startTime !== startTime || range.endTime !== endTime
        );

    this.filterByDepartureTime(listIndex);
  }

  private filterByDepartureTime(listIndex: number) {
    const flightDataFromStorage = JSON.parse(localStorage.getItem('flight_list_filter__'));
    const originalFlights = flightDataFromStorage[listIndex].flightlist;
    const selectedRanges = this.selectedDepartureTimeRanges[listIndex];

    // If no departure ranges are selected, reset to original flights
    this.list[listIndex].flightlist = selectedRanges.length === 0
      ? originalFlights
      : originalFlights.filter(flight => 
        selectedRanges.some(range => this.isFlightInTimeRange(this.getFlightTime(flight), range))
        );

    // Apply further filtering by arrival if there are selected ranges
    if (this.selectedArrivalTimeRanges[listIndex].length > 0) {
    this.filterByArrivalTime(listIndex);
    }
  }

  selectArrival(item: any, listname: any) {
    const listIndex = this.list.findIndex(list => list.name === listname);
    const selectedItem = this.activeTime[listIndex][item.id];
    selectedItem.isSelected_ = !selectedItem.isSelected_;
    const timeRanges = ['00:00-12:00', '12:01-18:00', '18:01-23:59'];
    const [startTime, endTime] = timeRanges[item.id].split('-');
    
    // Update selectedArrivalTimeRanges based on selection
    selectedItem.isSelected_
      ? this.selectedArrivalTimeRanges[listIndex].push({ startTime, endTime })
      : this.selectedArrivalTimeRanges[listIndex] = this.selectedArrivalTimeRanges[listIndex].filter(
          range => range.startTime !== startTime || range.endTime !== endTime
        );
      
    this.filterByArrivalTime(listIndex);
  }

  private filterByArrivalTime(listIndex: number) {
    const departureFilteredFlights = this.list[listIndex].flightlist;
    const selectedRanges = this.selectedArrivalTimeRanges[listIndex];

    // If no arrival ranges are selected, keep the departure-filtered flights
    this.list[listIndex].flightlist = selectedRanges.length === 0
      ? departureFilteredFlights
      : departureFilteredFlights.filter(flight => 
          selectedRanges.some(range => this.isFlightInTimeRange(this.getArrivalTime(flight), range))
        );
  }

  private isFlightInTimeRange(flightTime: number, range: { startTime: string, endTime: string }): boolean {
    const startTime = parseInt(range.startTime.replace(':', ''), 10);
    const endTime = parseInt(range.endTime.replace(':', ''), 10);
    return flightTime >= startTime && flightTime <= endTime;
  }

  private getArrivalTime(flight: any): number {
    return parseInt(flight.flightlegs?.[0]?.[flight.flightlegs[0].length - 1]?.arrtime.replace(':', '') || '0000', 10);
  }

  private getFlightTime(flight: any): number {
    return parseInt(flight.flightlegs?.[0]?.[0]?.deptime.replace(':', '') || '0000', 10);
  }

  showMoreInfo = false;

  toggleMoreInfo(event: MouseEvent) {
    event.stopPropagation();
    this.showMoreInfo = !this.showMoreInfo;
    // console.log('Toggle More Info:', this.showMoreInfo);
    if (this.showMoreInfo) {
      // Prevent main screen scrolling
      document.body.style.overflow = 'hidden';
    } else {
      // Restore scrolling on main screen
      document.body.style.overflow = 'auto';
    }
  }
  
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    // console.log('Document clicked:', this.list);
    if (this.showMoreInfo && !this.eRef.nativeElement.contains(event.target)) {
      // console.log('Clicked outside, closing info.');
      this.closeMoreInfo();
    }
  }

  closeMoreInfo() {
    this.showMoreInfo = false;
    // Restore main screen scrolling
    document.body.style.overflow = 'auto';
  };

  activeTab: string = 'FlightDetails'; // Default active tab

  selectTab(tab: string) {
    this.activeTab = tab;
  }

  adultNum: number = 0;
  childNum: number = 0;
  infantNum: number = 0;

  initializeValues() {
    // Retrieve numbers of adults, children, infants, etc.
    this.adultNum = JSON.parse(localStorage.getItem('adultValue') || '0');
    this.childNum = JSON.parse(localStorage.getItem('childValue') || '0');
    this.infantNum = JSON.parse(localStorage.getItem('infantsValue') || '0');
    // console.log(this.adultNum, this.childNum, this.infantNum);
  }
}
